import { useFormContext } from 'react-hook-form';
import { FormCheckbox } from 'redesign';
import { getRequiredMessage } from './shared';
import { IsTempworkFormContext, Props } from './is-tempwork.types';

export const IsTempworkCheckbox = (props: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IsTempworkFormContext>();
  const formName = 'isTempwork';
  const label = 'Uitzendkracht';
  const requiredMessage = getRequiredMessage(label);
  return (
    <FormCheckbox
      name={formName}
      control={control}
      label={label}
      disabled={props.disabled}
      rules={{
        ...(props.required ? { required: requiredMessage } : {}),
        ...(props.validate ? { validate: props.validate } : {}),
      }}
      onChange={props.onChange}
      checkboxError={errors.isTempwork?.message}
    />
  );
};
